import { Link } from "react-router-dom";
import { DataTable } from "@/components/app/DataTable";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { dl } from "@/components/order/ServiceReports";
import { useFetch } from "@/hooks/useFetch";
import { fmtDate, fmtDateTime } from "@/lib/format";

const COLS = [
  { key: "report_date", label: "Report date", render: (r) => fmtDate(r.report_date) }, { key: "report_type", label: "Report type" }, { key: "report_no", label: "Report no.", mono: true },
  { key: "order_no", label: "LM", render: (r) => <Link to={`/orders/${r.order_id}`} className="font-mono text-sky-700 hover:underline">{r.order_no}</Link> },
  { key: "done_by", label: "Engineer / vendor" }, { key: "assets", label: "Assets covered", wrap: true },
  { key: "uploaded_by", label: "Uploaded by / on", exp: (r) => `${r.uploaded_by || ""} ${r.uploaded_at || ""}`, render: (r) => <span className="text-xs">{r.uploaded_by}<br />{fmtDateTime(r.uploaded_at)}</span> },
  { key: "dl", label: "", exp: false, render: (r) => <Button size="sm" variant="ghost" className="h-7" onClick={() => dl({ id: r.doc_id, stored_name: r.stored_name })} data-testid={`sh-download-${r.doc_id}`}><Download className="h-4 w-4" /></Button> },
];

// Asset group / asset unit: service, commissioning and installation reports linked from LMs
export function ServiceHistory({ entityType, entityId }) {
  const { data } = useFetch(`/assets/service-history?entity_type=${entityType}&entity_id=${entityId}`);
  return <DataTable testid="service-history-table" columns={COLS} rows={data} exportName="Service_History" exportPerm="assets.export" empty="No service reports linked yet" />;
}
